// Meta pixel loader. Deliberately not the copy-paste snippet Meta hands you:
// that one runs on page load unconditionally, which we cannot do under UK-GDPR.
// Nothing here runs until someone calls initMetaPixel, and the only caller is
// gated on an explicit consent decision.

const SCRIPT_SRC = "https://connect.facebook.net/en_US/fbevents.js";

interface FbqFn {
  (...args: unknown[]): void;
  queue: unknown[][];
  loaded?: boolean;
  version?: string;
  push?: FbqFn;
  callMethod?: (...args: unknown[]) => void;
}

declare global {
  interface Window {
    fbq?: FbqFn;
    _fbq?: FbqFn;
  }
}

function ensureFbq(): FbqFn {
  if (window.fbq) return window.fbq;

  // The stub queues calls made before fbevents.js finishes loading; the real
  // library drains the queue via callMethod once it is ready.
  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
    } else {
      fbq.queue.push(args);
    }
  } as FbqFn;

  fbq.queue = [];
  fbq.loaded = true;
  fbq.version = "2.0";
  fbq.push = fbq;

  window.fbq = fbq;
  window._fbq = fbq;

  return fbq;
}

export function initMetaPixel(pixelId: string | undefined): void {
  if (!pixelId?.trim()) return;

  // Guard on the DOM rather than a module-level flag so this stays correct
  // across hot reloads and StrictMode's double-invoked effects.
  if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) return;

  const fbq = ensureFbq();

  const script = document.createElement("script");
  script.async = true;
  script.src = SCRIPT_SRC;
  document.head.appendChild(script);

  fbq("init", pixelId);
  fbq("track", "PageView");
}
